import * as actionTypes from './actionTypes'

import { getListingIndex } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'
import formAxios from '../../axios/form'

export const fetchForm = filterOptions => {
  return dispatch => {
    const params = {
      ...filterOptions,
      page: filterOptions ? filterOptions.page : 1,
      perPage: filterOptions ? filterOptions.perPage : 10
    }
    dispatch(fetchFormStart())
    formAxios
      .get('', { params })
      .then(response => {
        if (response.status === 200 && response.data.success) {
          const { current_page, from, last_page, per_page, to, total, data } = response.data.data

          const pagination = {
            currentPage: current_page,
            lastPage: last_page,
            perPage: per_page,
            from,
            to,
            total
          }

          const dataWithOption = data.map((item, index) => {
            return { ...item, index: getListingIndex(index, per_page, current_page) }
          })

          dispatch(fetchFormSuccess(pagination, dataWithOption))
        }
      })
      .catch(error => {
        dispatch(fetchFormFailed(error))
      })
  }
}

export const fetchFormStart = () => {
  return {
    type: actionTypes.FETCH_FORM_START
  }
}

export const fetchFormSuccess = (pagination, records) => {
  return {
    type: actionTypes.FETCH_FORM_SUCCESS,
    pagination,
    records
  }
}

export const fetchFormFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_FORM_FAILED,
    errorMessage
  }
}

export const fetchFormById = recordId => {
  return dispatch => {
    dispatch(fetchFormStart())
    formAxios
      .get(`/${recordId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchFormByIdSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchFormFailed(error))
      })
  }
}

export const fetchFormByIdSuccess = recordData => {
  return {
    type: actionTypes.FETCH_FORM_BY_ID_SUCCESS,
    recordData
  }
}

export const clearSelectedFormRecord = () => {
  return {
    type: actionTypes.CLEAR_SELECTED_FORM_RECORD
  }
}

export const createForm = (recordData, page) => {
  return dispatch => {
    dispatch(createFormStart())

    formAxios
      .post('', recordData)
      .then(response => {
        if (response.status === 201) {
          dispatch(
            enqueueSnackbar({
              message: 'Form Created',
              options: {
                variant: 'success'
              }
            })
          )
          dispatch(createFormSuccess())
          dispatch(fetchForm(page))
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Form field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(createFormFailed())
      })
  }
}

export const createFormStart = () => {
  return {
    type: actionTypes.CREATE_FORM_START
  }
}

export const createFormSuccess = () => {
  return {
    type: actionTypes.CREATE_FORM_SUCCESS
  }
}

export const createFormFailed = () => {
  return {
    type: actionTypes.CREATE_FORM_FAILED
  }
}

export const updateForm = (recordId, recordData, page) => {
  return dispatch => {
    dispatch(updateFormStart())

    formAxios
      .patch(`/${recordId}`, recordData)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Form Updated',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(updateFormSuccess())
        dispatch(fetchForm(page))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Invalid Form field',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(updateFormFailed())
      })
  }
}

export const updateFormStart = () => {
  return {
    type: actionTypes.UPDATE_FORM_START
  }
}

export const updateFormSuccess = () => {
  return {
    type: actionTypes.UPDATE_FORM_SUCCESS
  }
}

export const updateFormFailed = () => {
  return {
    type: actionTypes.UPDATE_FORM_FAILED
  }
}

export const deleteForm = (recordId, page) => {
  return dispatch => {
    dispatch(deleteFormStart())
    formAxios
      .delete(`/${recordId}`)
      .then(response => {
        dispatch(
          enqueueSnackbar({
            message: 'Form Deleted',
            options: {
              key: recordId,
              variant: 'success'
            }
          })
        )
        dispatch(deleteFormSuccess())
        dispatch(fetchForm(page))
      })
      .catch(error => {
        dispatch(
          enqueueSnackbar({
            message: 'Delete failed',
            options: {
              variant: 'error'
            }
          })
        )
        dispatch(deleteFormFailed())
      })
  }
}

export const deleteFormStart = () => {
  return {
    type: actionTypes.DELETE_FORM_START
  }
}

export const deleteFormSuccess = () => {
  return {
    type: actionTypes.DELETE_FORM_SUCCESS
  }
}

export const deleteFormFailed = () => {
  return {
    type: actionTypes.DELETE_FORM_FAILED
  }
}
